import { Layout } from "@/components/layout/Layout";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { page404 } from "@/const/page404";
import { createQueryDomTomPage } from "@/strapiQuery/domTomPage";
import {
  formatFirstDomTomPage,
  StrapiDomTomPage,
} from "@/utils/formatDomTomPage";
import { DepartmentDetails } from "@/interfaces/departmentDetails";
import { sendFetchRequest } from "@/utils/sendFetchRequest";
import { NetworkError } from "@/interfaces/errors/networkError";
import { routes } from "@/routes/routes";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

type GetStaticPropsParams = LoadI18nMessagesProps & {
  params: { slug: string };
};

const SLUG_NOT_FOUND_ERROR_CODE = 422;

export const getStaticProps = async (ctx: GetStaticPropsParams) => {
  const layout = await getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );
  const intlMessages = loadIntlMessages(ctx);

  let department: DepartmentDetails;
  try {
    department = await sendFetchRequest(`/states/v1/${ctx.params.slug}`).then(
      (json: DepartmentDetails) => json
    );
  } catch (error) {
    if (
      error instanceof NetworkError &&
      error.statusCode === SLUG_NOT_FOUND_ERROR_CODE
    ) {
      return page404;
    }
    throw error;
  }

  const strapiDomTomPages = await getStrapiCollection<StrapiDomTomPage>(
    "dom-tom-pages",
    createQueryDomTomPage(ctx.params.slug)
  );

  if (strapiDomTomPages.length === 0) {
    return page404;
  }

  const domTomPageContent = formatFirstDomTomPage(strapiDomTomPages);

  return {
    props: {
      layout,
      reviewsConst,
      intlMessages,
      department,
      slug: ctx.params.slug,
      ...domTomPageContent,
      defaultCanonicalRoute: routes.domTomPage(ctx.params.slug),
    },
    revalidate: 10,
  };
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export { DomTomPage as default } from "@/components/pages/agencies/domTomPage/DomTomPage";
